module.exports = __webpack_public_path__ + "016e483100ff926a4cb30bdab2c7ff84.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/furnitures/floor_items/chest.png
// module id = 972
// module chunks = 0